import {
  SET_CURRENT_USER,
  DELETE_CURRENT_USER
} from "../../constants/authConstants";

const INITIAL_STATE = {
  isLoggedIn: false
};
const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
        isLoggedIn: true
      };
    case DELETE_CURRENT_USER:
      return {
        ...state,
        currentUser: null,
        isLoggedIn: false
      };
    default:
      return state;
  }
};

export default authReducer;
